import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import register from "../Images/register.jpg";
import InputField from "../Components/InputField";
import AlertField from "../Components/AlertField";
import axios from "../shared";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [isPending, setIsPending] = useState(false);
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    re_password: "",
  });

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      placeholder: "Enter name",
      errorMessage: "Name shouldn't include any special character!",
      label: "Name",
      pattern: "^[A-Za-z ]{3,50}$",
      required: true,
    },
    {
      id: 2,
      name: "email",
      type: "email",
      placeholder: "Enter email",
      errorMessage: "Enter a valid email address!",
      label: "Email",
      required: true,
    },
    {
      id: 3,
      name: "password",
      type: "password",
      placeholder: "Enter password",
      errorMessage:
        "Password should be 8-20 characters and include at least 1 letter, 1 number and 1 special character!",
      label: "Password",
      pattern: `^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
    {
      id: 4,
      name: "re_password",
      type: "password",
      placeholder: "Enter password again",
      errorMessage: "Passwords don't match!",
      label: "Confirm Password",
      pattern: values.password,
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsPending(true);

    try {
      await axios.post(
        "auth/register/",
        JSON.stringify(values)
      );

      navigate("/login", {
        state: {
          message: "An activation link is sent to your registered mail.",
          type: "success",
        },
      });
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert("Account is already registered with this email.", "warning");
      } else {
        showAlert("Registration Failed", "warning");
      }
      setIsPending(false);
    }
  };

  return (
    <div>
      <AlertField alert={alert} />

      <div className="container my-md-5">
        <div
          className="row align-items-md-stretch"
        >
          <div className="col-md-6">
            <div className="h-100 text-bg-dark rounded-3">
              <img src={register} alt="cover" className="w-100 h-100" />
            </div>
          </div>

          <div className="col-md-6" style={{ height: 35 + "rem" }}>
            <div
              className="p-5 pt-3 bg-light border rounded-3 position-relative"
              style={{ height: 35 + "rem" }}
            >
              <h2 className="text-center">Register</h2>
              <form onSubmit={handleSubmit}>
                {inputs.map((input) => (
                  <InputField
                    key={input.id}
                    {...input}
                    value={values[input.name]}
                    onChange={onChange}
                  />
                ))}
                
                <div className="d-flex justify-content-end mt-2 position-absolute end-0 me-5 bottom-0" style={{zIndex: 1}}>
                  <p className="mx-1">Have an account?</p>
                  <a href="/login">Login</a>
                  <br />
                </div>
                <div className="text-center mb-1 w-100 start-0 position-absolute bottom-0 mb-4">
                  {isPending && (
                    <button className="btn btn-outline-dark m-2 py-2 px-5 disabled">
                      Submitting
                    </button>
                  )}
                  {!isPending && (
                    <button className="btn btn-primary m-2 py-2 px-5">
                      Submit
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
